import React, { useEffect } from 'react';
import { RouteSegmentDataForm } from '../../../../app/models/RouteSegment';
import { Place } from '../../../../app/models/Place';
import { Unit } from '../../../../app/models/Unit';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Currency } from '../../../../app/models/Currency';
import TransportationOrderRatesForm from '../../../TransportationOrders/components/forms/TransportationOrderRatesForm';

interface GeneralRouteSegmentProps {
    routeSegmentForm: RouteSegmentDataForm;
    setRouteSegmentForm: (routeSegment: RouteSegmentDataForm) => void;
    origins: Place[];
    destinations: Place[];
    currencies: Currency[];
    units: Unit[];
    errorFields?: any;
}

const RouteSegmentForm = ({
    routeSegmentForm,
    setRouteSegmentForm,
    origins,
    destinations,
    currencies,
    units,
    errorFields
}: GeneralRouteSegmentProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setRouteSegmentForm({ ...routeSegmentForm, [name]: value });
    };

    // const handleChangeSelectTwo = (name: string, value: number | string | null) => {
    //     setRouteSegmentForm({ ...routeSegmentForm, [name]: value });
    // };

    const handleRateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        if (String(name) == 'rate') {
            const foundCurrency = currencies.find(
                (item) => item.id === routeSegmentForm.currency_id
            );
            const currency = foundCurrency ? foundCurrency.name : '';
            if (currency === 'CLP') {
                setRouteSegmentForm({ ...routeSegmentForm, [name]: value.replace(/\D/g, '') });

                return;
            }
        } else if (String(name) == 'rate_runner') {
            const foundCurrency = currencies.find(
                (item) => item.id === routeSegmentForm.currency_rate_runner_id
            );
            const currency = foundCurrency ? foundCurrency.name : '';
            if (currency === 'CLP') {
                setRouteSegmentForm({ ...routeSegmentForm, [name]: value.replace(/\D/g, '') });

                return;
            }
        } else if (String(name) == 'rate_transporter') {
            const foundCurrency = currencies.find(
                (item) => item.id === routeSegmentForm.currency_rate_transporter_id
            );
            const currency = foundCurrency ? foundCurrency.name : '';
            if (currency === 'CLP') {
                setRouteSegmentForm({ ...routeSegmentForm, [name]: value.replace(/\D/g, '') });

                return;
            }
        }

        setRouteSegmentForm({ ...routeSegmentForm, [name]: value });
    };

    // const handleChangeSelectTwo = (name: string, value: number | string | null) => {
    //     setTransportationOrderForm({ ...transportationOrderForm, [name]: value });
    // };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        if (name == 'currency_id') {
            obj.rate = format_currency(routeSegmentForm.rate, value);
        } else if (name == 'currency_rate_runner_id') {
            obj.rate_runner = format_currency(routeSegmentForm.rate_runner, value);
        } else if (name == 'currency_rate_transporter_id') {
            obj.rate_transporter = format_currency(routeSegmentForm.rate_transporter, value);
        }

        setRouteSegmentForm({ ...routeSegmentForm, ...obj });
    };

    const format_currency = (currency_rate: any, value: any) => {
        let rate = String(currency_rate);

        const foundCurrency = currencies.find((item) => item.id === value);
        const currency = foundCurrency ? foundCurrency.name : '';

        if (currency_rate && currency === 'CLP') {
            const indice = rate.search(/\D/);

            if (indice !== -1) {
                rate = rate.substring(0, indice);
            }
        }

        return rate;
    };

    if (!routeSegmentForm) return null;

    return (
        <>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Origen</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="origin_id"
                        id="origin_id"
                        inputValue={routeSegmentForm.origin_id}
                        options={SelectTwoMapperOptions(origins)}
                        hasError={fieldHasError('origin_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('origin_id', value.value)}
                        placeholder={'Seleccione origen'}
                        onFocus={() => onFocusRemove('origin_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('origin_id')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Destino</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="destiny_id"
                        id="destiny_id"
                        inputValue={routeSegmentForm.destiny_id}
                        options={SelectTwoMapperOptions(destinations)}
                        hasError={fieldHasError('destiny_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('destiny_id', value.value)}
                        placeholder={'Seleccione destino'}
                        onFocus={() => onFocusRemove('destiny_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('destiny_id')}
                    </div>
                </div>
            </div>

            <div className="invalid-feedback mb-2" style={{ display: 'flex' }}>
                {fieldErrorMessage('non_field_errors')}
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Distancia</label>
                <div className="col-md-9">
                    <input
                        name="distance"
                        id="distance"
                        type="number"
                        className={`form-control ${fieldHasError('distance')}`}
                        value={routeSegmentForm.distance}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('distance')}
                        placeholder="Ingrese distancia del tramo"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('distance')}
                    </div>
                </div>
            </div>

            <hr />

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tarifa de venta</label>
                <div className="col-md-9 ">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                name="rate"
                                id="rate"
                                type="number"
                                className={`form-control ${fieldHasError('rate')}`}
                                value={routeSegmentForm.rate}
                                onChange={handleRateChange}
                                onFocus={() => onFocusRemove('rate')}
                                placeholder="Ingrese tarifa"
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('rate')}
                            </div>
                        </div>

                        <div className="col-3">
                            <SelectTwo
                                name="currency_id"
                                id="currency_id"
                                inputValue={routeSegmentForm.currency_id}
                                options={SelectTwoMapperOptions(currencies)}
                                hasError={fieldHasError('currency_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('currency_id', value.value)
                                }
                                onFocus={() => onFocusRemove('currency_id')}
                                placeholder={'moneda'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_id')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="unit_id"
                                id="unit_id"
                                inputValue={routeSegmentForm.unit_id}
                                options={SelectTwoMapperOptions(units)}
                                hasError={fieldHasError('unit_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('unit_id', value.value)
                                }
                                onFocus={() => onFocusRemove('unit_id')}
                                placeholder={'unidad'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('unit_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tarifa Runner</label>
                <div className="col-md-9 ">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                type="number"
                                name="rate_runner"
                                className={`form-control ${fieldHasError('rate_runner')}`}
                                id="rate_runner"
                                onFocus={() => onFocusRemove('rate_runner')}
                                value={routeSegmentForm.rate_runner}
                                onChange={handleRateChange}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('rate_runner')}
                            </div>
                        </div>

                        <div className="col-3">
                            <SelectTwo
                                name="currency_rate_runner_id"
                                id="currency_rate_runner_id"
                                inputValue={routeSegmentForm.currency_rate_runner_id}
                                options={SelectTwoMapperOptions(currencies)}
                                hasError={fieldHasError('currency_rate_runner_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('currency_rate_runner_id', value.value)
                                }
                                onFocus={() => onFocusRemove('currency_rate_runner_id')}
                                placeholder={'moneda'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_rate_runner_id')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="quantity_unit_rate_runner_id"
                                id="quantity_unit_rate_runner_id"
                                inputValue={routeSegmentForm.quantity_unit_rate_runner_id}
                                options={SelectTwoMapperOptions(units)}
                                hasError={fieldHasError('quantity_unit_rate_runner_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo(
                                        'quantity_unit_rate_runner_id',
                                        value.value
                                    )
                                }
                                onFocus={() => onFocusRemove('quantity_unit_rate_runner_id')}
                                placeholder={'unidad'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('quantity_unit_rate_runner_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tarifa Transportista</label>
                <div className="col-md-9 ">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                type="number"
                                name="rate_transporter"
                                className={`form-control ${fieldHasError('rate_transporter')}`}
                                id="rate_transporter"
                                onFocus={() => onFocusRemove('rate_transporter')}
                                value={routeSegmentForm.rate_transporter}
                                onChange={handleRateChange}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('rate_transporter')}
                            </div>
                        </div>

                        <div className="col-3">
                            <SelectTwo
                                name="currency_rate_transporter_id"
                                id="currency_rate_transporter_id"
                                inputValue={routeSegmentForm.currency_rate_transporter_id}
                                options={SelectTwoMapperOptions(currencies)}
                                hasError={fieldHasError('currency_rate_transporter_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo(
                                        'currency_rate_transporter_id',
                                        value.value
                                    )
                                }
                                onFocus={() => onFocusRemove('currency_rate_transporter_id')}
                                placeholder={'moneda'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_rate_transporter_id')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="quantity_unit_rate_transporter_id"
                                id="quantity_unit_rate_transporter_id"
                                inputValue={routeSegmentForm.quantity_unit_rate_transporter_id}
                                options={SelectTwoMapperOptions(units)}
                                hasError={fieldHasError('quantity_unit_rate_transporter_id') !== ''}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo(
                                        'quantity_unit_rate_transporter_id',
                                        value.value
                                    )
                                }
                                onFocus={() => onFocusRemove('quantity_unit_rate_transporter_id')}
                                placeholder={'unidad'}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('quantity_unit_rate_transporter_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RouteSegmentForm;
